module.exports = __webpack_public_path__ + "img/school-headline-mobile.cd110849.png";